import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores, useResponsive } from 'hooks';
import { ConfirmModal } from 'components/project/shared';
import { LaneContent } from '../LaneContent';

export const AuctionLaneContent = ({auctionId}) => {
  const {
    AuctionStore: {
      connected,
      laneList,
      openLanes,
    },
    UIStore: { handleJoinLane, handleExitLane },
  } = useStores(auctionId);

  const { isMobileView } = useResponsive();

  const handleClick = (item) => {
    if (isMobileView) {
      openLanes.forEach((laneID) => handleExitLane(auctionId, laneID));
      if (!openLanes.includes(item.laneID)) {
        handleJoinLane(auctionId, item.laneID);
        return;
      }

      return;
    }

    if (!openLanes.includes(item.laneID)) {
      handleJoinLane(auctionId, item.laneID);
    } else {
      handleExitLane(auctionId, item.laneID);
    }
  };

  return laneList.length > 0
    && connected
    && laneList.sort((a, b) => a.lane.localeCompare(b.lane))
      .map((item) => (
        openLanes.includes(item.laneID) ? (
          <ConfirmModal
            key={`Confirm_${item.laneID}`}
            title="Confirm Exit Lane"
            message={`Are you sure you would like to exit the '${item.lane}' lane?`}
            confirmText="Exit Lane"
            onConfirm={() => {
              handleClick(item);
            }}
            renderLink={(modal) => <LaneContent auctionId={auctionId} item={item} onClick={modal.open} key={item.laneID} />}
          />
        ) : (
          <LaneContent auctionId={auctionId} item={item} key={`LaneContent_${item.laneID}`} onClick={() => handleClick(item)} />
        )
      ));
};

export default observer(AuctionLaneContent);
